//removeIf(production)
import ClaroluzTypeChange from "../uploader/claroluz-type-change";
//endRemoveIf(production)

class claroluzActionBox {
    constructor() {
        this.toQrCodeClick();
        this.toPdfClick();
        this.toCupsClick();
    }

    private toQrCodeClick() {
        document.querySelectorAll('.claroluz-to-qr-code').forEach((element) => {
            element.addEventListener('click', () => {
                new ClaroluzTypeChange('type-qr');
            });
        });
    }    

    private toPdfClick() {
        document.querySelectorAll('.claroluz-to-pdf').forEach((element) => {
            element.addEventListener('click', () => {
                new ClaroluzTypeChange('type-pdf');
            });
        });
    }

    private toCupsClick() {
        document.querySelectorAll('.claroluz-to-cups').forEach((element) => {
            element.addEventListener('click', () => {
                new ClaroluzTypeChange('type-cups');
            });
        });
    }
}

//removeIf(production)
export default claroluzActionBox;
//endRemoveIf(production)